import api from './api'

export const historyService = {
  fetchHistory(params = {}) {
    const query = new URLSearchParams()
    const { page = 0, size = 10, entityType } = params
    query.append('page', page)
    query.append('size', size)
    if (entityType) query.append('entityType', entityType)
    return api.get(`/history?${query.toString()}`)
  }
}

